import { Location } from './../../_models/location';
import { Mahalle } from './../../_models/mahalle';
import { MeetingArea } from './../../_models/meeting-area';
import { MeetingAreasService } from './../../_services/meeting-areas.service';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController } from 'ionic-angular';
import { LocationPage } from '../location/location';
import { Geolocation } from '@ionic-native/geolocation';

@IonicPage()
@Component({
  selector: 'page-meeting-areas',
  templateUrl: 'meeting-areas.html',
})
export class MeetingAreasPage {
  meetingAreas: MeetingArea[] = [];
  filteredMeetingAreas: MeetingArea[] = [];
  mahalleler: Mahalle[];
  markers: Location[] = [];
  showMap: boolean;

  currentLatitude: Number;
  currentLongitude: Number;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private meetingAreaService: MeetingAreasService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private geolocation: Geolocation) {
    this.geolocation.getCurrentPosition().then((resp) => {
      this.currentLatitude = resp.coords.latitude;
      this.currentLongitude = resp.coords.longitude;
      console.log(resp.coords.latitude, resp.coords.longitude);
    }).catch((error) => {
      console.log('Error getting location', error);
    });

    this.meetingAreaService.getMahalleler().subscribe((mahalleler: Mahalle[]) => {
      this.mahalleler = mahalleler;
    }, error => console.log(error));

    this.getMeetingAreas();
  }

  getMeetingAreas() {
    const loader = this.loadingCtrl.create({
      content: "Yükleniyor...",
      duration: 3000
    });
    loader.present();

    this.meetingAreaService.getMeetingAreas().subscribe((areas: MeetingArea[]) => {
      this.filteredMeetingAreas = this.meetingAreas = areas;
      this.filterMarkers();
      loader.dismiss();
    }, error => console.log(error));
  }

  filterMarkers() {
    console.log(this.filteredMeetingAreas);
    this.markers = [];
    this.filteredMeetingAreas.forEach(area => {
      this.markers.push({ 
        name: area.adi, 
        adres: area.adres, 
        latitude: +area.latitude, 
        longitude: +area.longitude, 
        iconUrl: 'assets/imgs/toplanma-alani-small.png', 
        strokeColor: 'green',
        currentLatitude: this.currentLatitude,
        currentLongitude: this.currentLongitude
      })
    });
  }

  filter(mahalleId) {
    this.filteredMeetingAreas = (mahalleId) ?
      this.meetingAreas.filter(p => p.mahalle.id == mahalleId) :
      this.meetingAreas;
      this.filterMarkers();
  }

  changeView(toggleView) {
    this.showMap = toggleView.checked
  }

  onOpenMap(lat, lng, area) {
    const modal = this.modalCtrl.create(LocationPage, {
      latitude: lat,
      longitude: lng,
      locationName: area.adi,
      adres: area.adres,
      iconUrl: 'assets/imgs/toplanma-alani-small.png',
      currentLatitude: this.currentLatitude,
      currentLongitude: this.currentLongitude
    });
    modal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/meeting-areas/meeting-areas.ts